import React from 'react';

interface IconProps extends React.SVGProps<SVGSVGElement> {
  fill?: string;
  size?: number | string;
  width?: number | string;
  height?: number | string;
}

export function StoresIcon({ size = 12, ...props }: IconProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M14.8341 19.834V15.6673C14.8341 15.4463 14.7463 15.2343 14.59 15.0781C14.4337 14.9218 14.2218 14.834 14.0008 14.834H10.6674C10.4464 14.834 10.2345 14.9218 10.0782 15.0781C9.9219 15.2343 9.83411 15.4463 9.83411 15.6673V19.834"
        stroke="currentColor"
        strokeWidth="1.66667"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M17.1458 10.925C16.9721 10.7587 16.7408 10.6659 16.5004 10.6659C16.2599 10.6659 16.0287 10.7587 15.8549 10.925C15.4674 11.2946 14.9525 11.5008 14.417 11.5008C13.8815 11.5008 13.3666 11.2946 12.9791 10.925C12.8054 10.7589 12.5744 10.6663 12.3341 10.6663C12.0938 10.6663 11.8628 10.7589 11.6891 10.925C11.3016 11.2948 10.7865 11.5012 10.2508 11.5012C9.71508 11.5012 9.19998 11.2948 8.81244 10.925C8.63872 10.7587 8.40751 10.6659 8.16702 10.6659C7.92653 10.6659 7.69533 10.7587 7.52161 10.925C7.14731 11.2822 6.6535 11.4873 6.1363 11.5005C5.61909 11.5136 5.11549 11.3338 4.72353 10.9961C4.33156 10.6585 4.07927 10.187 4.01576 9.67354C3.95225 9.16008 4.08207 8.64135 4.37994 8.21833L6.78744 4.73167C6.9402 4.50626 7.14585 4.32171 7.38642 4.19416C7.62699 4.06661 7.89515 3.99995 8.16744 4H16.5008C16.7723 3.9999 17.0397 4.06612 17.2798 4.19291C17.5198 4.3197 17.7253 4.50321 17.8783 4.7275L20.2908 8.22083C20.5887 8.64419 20.7184 9.16331 20.6545 9.67703C20.5906 10.1908 20.3377 10.6623 19.9451 10.9997C19.5525 11.3372 19.0483 11.5164 18.5308 11.5024C18.0133 11.4885 17.5196 11.2823 17.1458 10.9242"
        stroke="currentColor"
        strokeWidth="1.66667"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.66743 11.459V18.1673C5.66743 18.6093 5.84303 19.0333 6.15559 19.3458C6.46815 19.6584 6.89207 19.834 7.3341 19.834H17.3341C17.7761 19.834 18.2001 19.6584 18.5126 19.3458C18.8252 19.0333 19.0008 18.6093 19.0008 18.1673V11.459"
        stroke="currentColor"
        strokeWidth="1.66667"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function OrdersIcon({ size = 12, ...props }: IconProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M8.95833 20.6247C9.41857 20.6247 9.79167 20.2516 9.79167 19.7913C9.79167 19.3311 9.41857 18.958 8.95833 18.958C8.4981 18.958 8.125 19.3311 8.125 19.7913C8.125 20.2516 8.4981 20.6247 8.95833 20.6247Z"
        stroke="currentColor"
        strokeWidth="1.66667"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M18.125 20.6247C18.5852 20.6247 18.9583 20.2516 18.9583 19.7913C18.9583 19.3311 18.5852 18.958 18.125 18.958C17.6648 18.958 17.2917 19.3311 17.2917 19.7913C17.2917 20.2516 17.6648 20.6247 18.125 20.6247Z"
        stroke="currentColor"
        strokeWidth="1.66667"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4 4H5.66667L7.88333 14.35C7.96465 14.729 8.17556 15.0679 8.47976 15.3082C8.78396 15.5485 9.16242 15.6753 9.55 15.6667H17.7C18.0793 15.6661 18.4471 15.5361 18.7425 15.2982C19.038 15.0603 19.2434 14.7288 19.325 14.3583L20.7 8.16667H6.55833"
        stroke="currentColor"
        strokeWidth="1.66667"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function DepartmentsIcon({ size = 12, ...props }: IconProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M10.4166 18.333H3.39993C2.43327 18.333 1.6416 17.558 1.6416 16.608V4.24131C1.6416 2.05797 3.2666 1.06631 5.25827 2.04131L8.95827 3.85797C9.75827 4.24964 10.4166 5.29131 10.4166 6.17464V18.333Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M18.3084 12.5503V15.7003C18.3084 17.5003 17.4751 18.3336 15.6751 18.3336H10.4167V8.68359L10.8084 8.76693L14.5584 9.60859L16.2501 9.98359C17.3501 10.2253 18.2501 10.7919 18.3001 12.3919C18.3084 12.4419 18.3084 12.4919 18.3084 12.5503Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4.58325 7.5H7.47492"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4.58325 10.834H7.47492"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.5583 9.60924V12.2926C14.5583 13.3259 13.7167 14.1676 12.6833 14.1676C11.65 14.1676 10.8083 13.3259 10.8083 12.2926V8.76758L14.5583 9.60924Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M18.3 12.3927C18.25 13.376 17.4333 14.1677 16.4333 14.1677C15.4 14.1677 14.5583 13.326 14.5583 12.2927V9.60938L16.25 9.98437C17.35 10.226 18.25 10.7927 18.3 12.3927Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function LogOutIcon({ fill = 'currentColor', size = 25, ...props }: IconProps) {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M13.3335 14.1663L17.5002 9.99967L13.3335 5.83301"
        stroke="currentColor"
        strokeWidth="1.66667"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M17.5 10H7.5"
        stroke="currentColor"
        strokeWidth="1.66667"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.5 17.5H4.16667C3.72464 17.5 3.30072 17.3244 2.98816 17.0118C2.67559 16.6993 2.5 16.2754 2.5 15.8333V4.16667C2.5 3.72464 2.67559 3.30072 2.98816 2.98816C3.30072 2.67559 3.72464 2.5 4.16667 2.5H7.5"
        stroke="currentColor"
        strokeWidth="1.66667"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function CardIcon({ fill = 'currentColor', size = 12, ...props }: IconProps) {
  return (
    <svg
      height={size}
      viewBox="0 0 16 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M12.6544 0.538086H2.42368C1.38283 0.538086 0.539062 1.38186 0.539062 2.4227V9.4227C0.539062 10.4635 1.38283 11.3073 2.42368 11.3073H12.6544C13.6953 11.3073 14.5391 10.4635 14.5391 9.4227V2.4227C14.5391 1.38186 13.6953 0.538086 12.6544 0.538086Z"
        stroke={fill}
        strokeWidth="1.07692"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M0.539062 3.76953H14.5391M3.23137 7.40415H4.84676V8.07722H3.23137V7.40415Z"
        stroke={fill}
        strokeWidth="2.01923"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function RolesIcon({ fill = 'currentColor', size = 25, ...props }: IconProps) {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M11.0784 12.4541C11.4719 12.4541 11.7913 12.7745 11.7913 13.167C11.7911 13.5603 11.4718 13.8799 11.0784 13.8799C8.46025 13.8799 6.13755 14.4987 4.70636 15.4756C3.90268 16.0225 3.39679 16.6564 3.39679 17.3643V18.6465C3.39684 18.6797 3.40959 18.711 3.4339 18.7354C3.45747 18.7589 3.48977 18.7733 3.52277 18.7734H11.0784C11.4721 18.7725 11.7913 19.0928 11.7913 19.4854C11.7911 19.8786 11.4716 20.1973 11.0784 20.1982H3.52277C3.11101 20.1982 2.71623 20.0343 2.42511 19.7441C2.13391 19.4529 1.97106 19.0573 1.97101 18.6465V17.3643C1.97101 16.2227 2.6632 15.1421 3.90265 14.2969C5.52679 13.1897 8.13614 12.4542 11.0784 12.4541Z"
        fill="currentColor"
        stroke="currentColor"
        strokeWidth="0.1"
      />
      <path
        d="M11.0787 1.96973C13.7893 1.96973 15.9889 4.16944 15.9889 6.87988C15.9888 9.59025 13.7892 11.79 11.0787 11.79C8.36826 11.79 6.16867 9.59025 6.16858 6.87988C6.16858 4.16944 8.36821 1.96973 11.0787 1.96973ZM11.0787 3.39551C9.15514 3.39551 7.59436 4.95635 7.59436 6.87988C7.59445 8.80334 9.15519 10.3643 11.0787 10.3643C13.0023 10.3643 14.563 8.80334 14.5631 6.87988C14.5631 4.95635 13.0023 3.39551 11.0787 3.39551Z"
        fill="currentColor"
        stroke="currentColor"
        strokeWidth="0.1"
      />
      <path
        d="M16.3807 13.1807C18.1456 13.1807 19.5798 14.6131 19.5799 16.3779C19.5799 18.1428 18.1456 19.5762 16.3807 19.5762C14.6158 19.576 13.1834 18.1427 13.1834 16.3779C13.1835 14.6132 14.6159 13.1808 16.3807 13.1807ZM16.3807 14.6064C15.4028 14.6066 14.6083 15.4001 14.6082 16.3779C14.6082 17.3558 15.4028 18.1512 16.3807 18.1514C17.3587 18.1514 18.1541 17.3559 18.1541 16.3779C18.154 15.4 17.3587 14.6064 16.3807 14.6064Z"
        fill="currentColor"
        stroke="currentColor"
        strokeWidth="0.1"
      />
      <path
        d="M16.3813 11.6885C16.7746 11.6886 17.0941 12.008 17.0941 12.4014V13.8916C17.0941 14.285 16.7745 14.6044 16.3813 14.6055C15.9877 14.6055 15.6684 14.2851 15.6684 13.8926V12.4014C15.6684 12.0079 15.9878 11.6885 16.3813 11.6885Z"
        fill="currentColor"
        stroke="currentColor"
        strokeWidth="0.1"
      />
      <path
        d="M18.6888 13.0615C18.9663 12.783 19.419 12.783 19.6966 13.0615L19.7884 13.1729C19.9448 13.4096 19.9448 13.7203 19.7884 13.957L19.6966 14.0684L18.6429 15.124H18.6419C18.3983 15.3664 18.0229 15.3966 17.7464 15.2148L17.6341 15.124C17.3566 14.8456 17.3566 14.3937 17.6341 14.1152L18.6888 13.0615Z"
        fill="currentColor"
        stroke="currentColor"
        strokeWidth="0.1"
      />
      <path
        d="M20.3573 15.665C20.7508 15.665 21.0702 15.9845 21.0702 16.3779C21.07 16.7712 20.7507 17.0908 20.3573 17.0908H18.8661C18.4738 17.0908 18.1535 16.7713 18.1542 16.3779C18.1542 15.9845 18.4735 15.665 18.8661 15.665H20.3573Z"
        fill="currentColor"
        stroke="currentColor"
        strokeWidth="0.1"
      />
      <path
        d="M17.7464 17.5439C18.023 17.362 18.3983 17.3922 18.6419 17.6348H18.6429L19.6966 18.6895L19.7884 18.8018C19.9447 19.0385 19.9449 19.3492 19.7884 19.5859L19.6966 19.6973C19.419 19.9757 18.9663 19.9758 18.6888 19.6973L17.6341 18.6426C17.3567 18.3641 17.3566 17.9131 17.6341 17.6348L17.7464 17.5439Z"
        fill="currentColor"
        stroke="currentColor"
        strokeWidth="0.1"
      />
      <path
        d="M16.3813 18.1533C16.7745 18.1544 17.0941 18.4736 17.0941 18.8662V20.3574C17.0941 20.7508 16.7746 21.0701 16.3813 21.0703C15.9878 21.0703 15.6684 20.7509 15.6684 20.3574V18.8662C15.6684 18.4737 15.9877 18.1533 16.3813 18.1533Z"
        fill="currentColor"
        stroke="currentColor"
        strokeWidth="0.1"
      />
      <path
        d="M14.1194 17.6348C14.3978 17.3573 14.8497 17.3573 15.1281 17.6348L15.219 17.7471C15.4008 18.0236 15.3706 18.399 15.1281 18.6426L14.0725 19.6973C13.8296 19.9408 13.4532 19.9709 13.177 19.7881L13.0656 19.6973C12.7871 19.4197 12.7871 18.967 13.0656 18.6895L14.1194 17.6348Z"
        fill="currentColor"
        stroke="currentColor"
        strokeWidth="0.1"
      />
      <path
        d="M13.8948 15.665C14.2883 15.665 14.6077 15.9845 14.6077 16.3779C14.6084 16.7714 14.288 17.0908 13.8948 17.0908H12.4046C12.0112 17.0908 11.6919 16.7712 11.6917 16.3779C11.6917 15.9845 12.0111 15.665 12.4046 15.665H13.8948Z"
        fill="currentColor"
        stroke="currentColor"
        strokeWidth="0.1"
      />
      <path
        d="M13.0656 13.0615C13.3432 12.7831 13.7949 12.783 14.0725 13.0615L15.1281 14.1152C15.4056 14.3937 15.4056 14.8456 15.1281 15.124C14.8497 15.4015 14.3978 15.4015 14.1194 15.124L13.0656 14.0684C12.7871 13.7908 12.7872 13.3391 13.0656 13.0615Z"
        fill="currentColor"
        stroke="currentColor"
        strokeWidth="0.1"
      />
    </svg>
  );
}

export function RolesEditIcon({ fill = 'currentColor', size = 25, ...props }: IconProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M15.3334 4.16797H8.66675C5.33341 4.16797 3.66675 5.83464 3.66675 9.16797V20.0013C3.66675 20.4596 4.04175 20.8346 4.50008 20.8346H15.3334C18.6667 20.8346 20.3334 19.168 20.3334 15.8346V9.16797C20.3334 5.83464 18.6667 4.16797 15.3334 4.16797Z"
        stroke="currentColor"
        strokeWidth="1.3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.7583 9.03053L8.43332 13.3555C8.26666 13.5222 8.10833 13.8472 8.07499 14.0805L7.84166 15.7305C7.75833 16.3305 8.17499 16.7472 8.77499 16.6639L10.425 16.4305C10.6583 16.3972 10.9833 16.2389 11.15 16.0722L15.475 11.7472C16.2167 11.0055 16.575 10.1389 15.475 9.03886C14.375 7.93053 13.5083 8.28053 12.7583 9.03053Z"
        stroke="currentColor"
        strokeWidth="1.3"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.1416 9.64844C12.5083 10.9568 13.5333 11.9901 14.8499 12.3568"
        stroke="currentColor"
        strokeWidth="1.3"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function FunctionsIcon({ fill = 'currentColor', size = 25, ...props }: IconProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M13.01 2.92031L18.91 5.54031C20.61 6.29031 20.61 7.53031 18.91 8.28031L13.01 10.9003C12.34 11.2003 11.24 11.2003 10.57 10.9003L4.67002 8.28031C2.97002 7.53031 2.97002 6.29031 4.67002 5.54031L10.57 2.92031C11.24 2.62031 12.34 2.62031 13.01 2.92031Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3 11C3 11.84 3.63 12.81 4.4 13.15L11.19 16.17C11.71 16.4 12.3 16.4 12.81 16.17L19.6 13.15C20.37 12.81 21 11.84 21 11"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3 16C3 16.93 3.55 17.77 4.4 18.15L11.19 21.17C11.71 21.4 12.3 21.4 12.81 21.17L19.6 18.15C20.45 17.77 21 16.93 21 16"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function SheetIcon({ fill = 'currentColor', size = 25, ...props }: IconProps) {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M9 22H15C20 22 22 20 22 15V9C22 4 20 2 15 2H9C4 2 2 4 2 9V15C2 20 4 22 9 22Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2.03 8.5H22"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2.03 15.5H22"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.51 21.9917V2.01172"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.51 21.9917V2.01172"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function PermissionIcon({ fill = 'currentColor', size = 24, ...props }: IconProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M20.91 11.1203C20.91 16.0103 17.36 20.5903 12.51 21.9303C12.18 22.0203 11.82 22.0203 11.49 21.9303C6.63999 20.5903 3.09 16.0103 3.09 11.1203V6.73028C3.09 5.91028 3.71001 4.98028 4.48001 4.67028L10.05 2.39031C11.3 1.88031 12.71 1.88031 13.96 2.39031L19.53 4.67028C20.29 4.98028 20.92 5.91028 20.92 6.73028L20.91 11.1203Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12 12.5C13.1046 12.5 14 11.6046 14 10.5C14 9.39543 13.1046 8.5 12 8.5C10.8954 8.5 10 9.39543 10 10.5C10 11.6046 10.8954 12.5 12 12.5Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12 12.5V15.5"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function UserIcon({ fill = 'currentColor', size = 24, ...props }: IconProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M12 12C14.7614 12 17 9.76142 17 7C17 4.23858 14.7614 2 12 2C9.23858 2 7 4.23858 7 7C7 9.76142 9.23858 12 12 12Z"
        stroke="currentColor"
        strokeWidth="1.8"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M20.5899 22C20.5899 18.13 16.7399 15 11.9999 15C7.25991 15 3.40991 18.13 3.40991 22"
        stroke="currentColor"
        strokeWidth="1.8"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function TeamsIcon({ fill = 'currentColor', size = 24, ...props }: IconProps) {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path d="M18 7.16C17.94 7.15 17.87 7.15 17.81 7.16C16.43 7.11 15.33 5.98 15.33 4.58C15.33 3.15 16.48 2 17.91 2C19.34 2 20.49 3.16 20.49 4.58C20.48 5.98 19.38 7.11 18 7.16Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M16.9699 14.4402C18.3399 14.6702 19.8499 14.4302 20.9099 13.7202C22.3199 12.7802 22.3199 11.2402 20.9099 10.3002C19.8399 9.59016 18.3099 9.35016 16.9399 9.59016" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M5.96998 7.16C6.02998 7.15 6.09998 7.15 6.15998 7.16C7.53998 7.11 8.63998 5.98 8.63998 4.58C8.63998 3.15 7.48998 2 6.05998 2C4.62998 2 3.47998 3.16 3.47998 4.58C3.48998 5.98 4.58998 7.11 5.96998 7.16Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M6.99994 14.4402C5.62994 14.6702 4.11994 14.4302 3.05994 13.7202C1.64994 12.7802 1.64994 11.2402 3.05994 10.3002C4.12994 9.59016 5.65994 9.35016 7.02994 9.59016" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M12 14.6307C11.94 14.6207 11.87 14.6207 11.81 14.6307C10.43 14.5807 9.32996 13.4507 9.32996 12.0507C9.32996 10.6207 10.48 9.4707 11.91 9.4707C13.34 9.4707 14.49 10.6307 14.49 12.0507C14.48 13.4507 13.38 14.5907 12 14.6307Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M9.08997 17.7813C7.67997 18.7213 7.67997 20.2613 9.08997 21.2013C10.69 22.2713 13.31 22.2713 14.91 21.2013C16.32 20.2613 16.32 18.7213 14.91 17.7813C13.32 16.7213 10.69 16.7213 9.08997 17.7813Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    </svg>

  );
}

export function SettingsIcon({ fill = 'none', size = 24, ...props }: IconProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
      {...props}
    >
      <path d="M12.22 2h-.44a2 2 0 0 0-2 2v.18a2 2 0 0 1-1 1.73l-.43.25a2 2 0 0 1-2 0l-.15-.08a2 2 0 0 0-2.73.73l-.22.38a2 2 0 0 0 .73 2.73l.15.1a2 2 0 0 1 1 1.72v.51a2 2 0 0 1-1 1.74l-.15.09a2 2 0 0 0-.73 2.73l.22.38a2 2 0 0 0 2.73.73l.15-.08a2 2 0 0 1 2 0l.43.25a2 2 0 0 1 1 1.73V20a2 2 0 0 0 2 2h.44a2 2 0 0 0 2-2v-.18a2 2 0 0 1 1-1.73l.43-.25a2 2 0 0 1 2 0l.15.08a2 2 0 0 0 2.73-.73l.22-.39a2 2 0 0 0-.73-2.73l-.15-.08a2 2 0 0 1-1-1.74v-.5a2 2 0 0 1 1-1.74l.15-.09a2 2 0 0 0 .73-2.73l-.22-.38a2 2 0 0 0-2.73-.73l-.15.08a2 2 0 0 1-2 0l-.43-.25a2 2 0 0 1-1-1.73V4a2 2 0 0 0-2-2z" />
      <circle cx="12" cy="12" r="3" />
    </svg>
  );
}

export function FactoriesIcon({ fill = 'none', size = 24, ...props }: IconProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
      {...props}
    >
      <path d="M2 20a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V8l-7 5V8l-7 5V4a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2Z" />
      <path d="M17 18h1" />
      <path d="M12 18h1" />
      <path d="M7 18h1" />
    </svg>
  );
}

